import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  padding-bottom: 130px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;
  border-radius: 10px;
  background-color: var(--bottom-color-sefaz);
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 20px;
  padding-bottom: 30px;
  min-height: 300px;
  width: 95%;
`;

export const Titulo = styled.div`
  display: block;
  text-align: center;
  margin: auto;
  margin-top: 25px;
  h1,
  h3 {
    margin: 0;
    color: var(--primary-color-sefaz);
  }
  h1 {
    font-weight: 600;
    font-size: 50pt;
  }
  h3 {
    font-size: 25pt;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
`;
